import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useSelector, useDispatch } from 'react-redux';

const ReportMenu = props => {
	//props: onDelete / onEdit
	const [ anchorEl, setAnchorEl ] = useState(null);
	const root = useSelector(state => state.api).root;
  const user = useSelector(state => state.user);
  const { commentId, updateContent } = props;

  const handleMenuClick = event => {
    return;
    setAnchorEl(event.currentTarget);
  }
  const handleClose = () => {
		setAnchorEl(null);
    props.setMouseOver(false);
  };

	const report = () => {
		fetch(`${root}/api/report/comment/${props.commentId}/1`, { method: 'get', credentials: 'include'  })
			.then(res => {
				console.log(res);
			})
			.catch(err => console.log(err))
    updateContent(draft => {
      draft.comments = draft.comments.filter(comment => comment._id !== commentId);
      draft.commentCount--;
    });
    handleClose();
    //activate report alert
    props.handleOpen();
	};

	return (
        <div>
      <IconButton
          edge="end"
          aria-controls='simple-menu'
          aria-label="aria-haspopup"
          onClick={handleMenuClick}
          size="large">
				<MoreVertIcon/>
			</IconButton>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem onClick={report}>Report</MenuItem>
				<MenuItem onClick={handleClose}>Cancle</MenuItem>
			</Menu>
		</div>
    );
}

export default ReportMenu;
